<template>
  <div class="tzLoadingBar">
    <slot></slot>
    <div class="tzLoadingBar__container">
      <div class="tzLoadingBar__percentage" :style="{ width: percentageText }">
        <div
          class="tzLoadingBar__indicator"
          v-if="showIndicator"
          :class="'tzLoadingBar__indicator--' + percentage"
        >
          {{ percentageText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TzLoadingBar',
  computed: {
    percentageText() {
      return this.percentage + '%';
    }
  },
  props: {
    // If true an indicator of the percentage will be added to the loading bar
    showIndicator: {
      type: Boolean,
      default: false
    },
    // Number representing where the bar should start.
    startingPosition: {
      type: Number,
      required: true
    },
    // The number of milliseconds between incrementing the percentage
    delay: {
      type: Number,
      default: 180
    }
  },
  data() {
    return {
      percentage: this.startingPosition
    };
  },
  created() {
    this.startTimer();
  },
  watch: {
    percentage: function(newVal, oldVal) {
      if (newVal === 100 && oldVal !== newVal) {
        this.$emit('tz-loading-bar-completed');
      }
    }
  },
  methods: {
    startTimer() {
      let intVal = setInterval(() => {
        if (this.percentage < 100) {
          this.percentage++;
        } else {
          clearInterval(intVal);
        }
      }, this.delay);
    }
  }
};
</script>
